import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { Button } from 'app/components/Common/Button'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { styles } from 'app/theme'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo } from 'react'

export interface Props {
  description?: string
  image?: ImageProps
  languageCode: string
  title: string
  URL?: string
}

export const Item = memo(function Item({
  description,
  image,
  languageCode,
  title,
  URL,
}: Props) {
  if (!title) {
    return null
  }

  return (
    <Container>
      <Background>{image ? <Image {...image} /> : null}</Background>

      <Wrapper>
        {title ? <Title tag="h2" text={title} /> : null}

        {description ? (
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        ) : null}

        {URL ? (
          <CTA
            label={useVocabularyData('ask', languageCode)}
            URL={URL}
            variant="flat"
          />
        ) : null}
      </Wrapper>
    </Container>
  )
})

const Container = styled.div`
  margin-top: 3rem;
`

const Background = styled.div`
  aspect-ratio: 1.48;
  overflow: hidden;
  position: relative;

  img {
    ${styles.img}
  }
`

const Wrapper = styled.div`
  margin-top: 2rem;

  @media (max-width: 1199px) {
    margin-top: 1.5rem;
  }
`

const Title = styled(AnimatedTitle)`
  ${styles.title.small}

  @media (max-width: 1199px) {
    > div {
      > div {
        opacity: 1 !important;
        transform: none !important;
      }
    }
  }
`

const Description = styled.div`
  ${styles.description}

  margin-top: 18px;
`

const CTA = styled(Button)`
  margin-top: 2rem;

  @media (max-width: 1199px) {
    margin-top: 1.5rem;
  }
`
